import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseSharedModule } from '@fuse/shared.module';

import { FuseToolbarComponent } from './toolbar.component';
import { FuseSearchBarModule } from '@fuse/components';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { DxLookupModule, DxMenuModule } from 'devextreme-angular';

@NgModule({
    declarations: [
        FuseToolbarComponent,
    ],
    imports: [
        RouterModule,
        MatMenuModule,
        MatProgressBarModule,
        MatToolbarModule,
        MatTooltipModule,

        FuseSharedModule,
        FuseSearchBarModule,

        DxMenuModule,
        DxLookupModule,
        ComponentsModule,
    ],
    exports: [
        FuseToolbarComponent,
    ],
    providers: [
        // DefaultDataService,
    ]
})
export class FuseToolbarModule {
}
